import axios from 'axios'
import { NODE_BASE_URL, getAxiosOptions } from './serviceHelper'

export const previewService = {
  getPreviewData: async (user, processId) => {
    return (await axios.get(`${NODE_BASE_URL}/preview/${processId}`, getAxiosOptions(user))).data
  },
}
